module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pleg12-b171d355e510616d0e460be33aa7c0f5.jpg";